import t from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import g from "./iconfont.es5471.js";
const m = {
  display: "block"
}, f = ({ size: a = 16, useVw: e, useRem: c, color: o, withColor: l, removeClassName: n, disableSSR: x, style: i, ...d }) => {
  const p = i ? { ...m, ...i } : m;
  return /* @__PURE__ */ t.createElement(g, { disableSSR: x }, /* @__PURE__ */ t.createElement("svg", { "data-icon-id": "32px-wuxianwangge", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: e ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), height: e ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), className: n ? "" : "iconpark-icon", style: p, fill: "none", ...d }, /* @__PURE__ */ t.createElement(
    "g",
    {
      className: n ? "" : "32px-æ éç½æ ¼"
    },
    /* @__PURE__ */ t.createElement(
      "path",
      {
        className: n ? "" : "normal",
        d: "M4.1 5.34a.9.9 0 0 1 .9-.9h22a.9.9 0 1 1 0 1.8H5a.9.9 0 0 1-.9-.9Zm0 21.323a.9.9 0 0 1 .9-.9h22a.9.9 0 1 1 0 1.8H5a.9.9 0 0 1-.9-.9Zm10.578-15.104a5.554 5.554 0 1 0-6.665 8.886.9.9 0 1 0 1.08-1.44 3.754 3.754 0 1 1 4.505-6.006.9.9 0 0 0 1.08-1.44Zm2.472 4.146c.545-1.102.945-1.913 1.432-2.507.272-.331.545-.558.85-.707.305-.148.69-.243 1.221-.243a.9.9 0 1 0 0-1.8c-.755 0-1.418.137-2.01.425-.59.288-1.057.701-1.453 1.184-.63.769-1.142 1.81-1.682 2.907-.103.21-.207.422-.314.635l-.346.7c-.545 1.102-.945 1.912-1.432 2.506-.271.332-.544.558-.85.707-.305.148-.69.244-1.22.244a.9.9 0 1 0 0 1.8c.754 0 1.418-.138 2.009-.426.59-.287 1.058-.7 1.453-1.184.63-.769 1.142-1.809 1.682-2.907l.314-.635c.123-.245.238-.478.347-.699Zm6.835-4.146a.9.9 0 1 0-1.08 1.44 3.752 3.752 0 0 1-1.721 6.719 3.751 3.751 0 0 1-2.783-.713.9.9 0 0 0-1.08 1.44 5.554 5.554 0 0 0 6.664-8.886Z",
        fill: l ? r(o, 0, "#262933") : "#262933",
        datafollowfill: l ? r(o, 0, "#262933") : "#262933"
      }
    )
  )));
}, h = f;
export {
  h as default
};
